import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
const originalPush = Router.prototype.push
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index',
    },
    {
      path: '/index',
      name:'Home',
      component: resolve => require(['@/view/index'], resolve)
    },
    {
      path: '/about',
      name:'About',
      component: resolve => require(['@/view/about/index'], resolve)
    },
    {
      path: '/news',
      name:'News',
      component: resolve => require(['@/view/about/news'], resolve)
    },
    {
      path: '/history',
      name:'History',
      component: resolve => require(['@/view/about/history'], resolve)
    },
    {
      path: '/coreUser',
      name:'CoreUser',
      component: resolve => require(['@/view/about/coreUser'], resolve)
    },
    {
      path: '/jobs',
      name:'Jobs',
      component: resolve => require(['@/view/about/jobs'], resolve)
    },
    {
      path: '/contact',
      name:'Contact',
      component: resolve => require(['@/view/about/contact'], resolve)
    },
    {
      path: '/search',
      name:'Search',
      component: resolve => require(['@/view/about/search'], resolve)
    },
    {
      path: '/userClass',
      component: {render: (e) => e("router-view")},
      redirect: '/userClass/client',
      children: [
        {
          path: 'client',
          component: resolve => require(['@/view/userClass/client'], resolve),
        },
        {
          path: 'collaborator',
          component: resolve => require(['@/view/userClass/collaborator'], resolve),
        },
        {
          path: 'investor',
          component: resolve => require(['@/view/userClass/investor'], resolve),
        },
        {
          path: 'jobseeker',
          component: resolve => require(['@/view/userClass/jobseeker'], resolve),
        }
      ]
    },

    {
      path: '/article/:id',
      name:'Article',
      component: resolve => require(['@/view/article/index'], resolve)
    },



    {
      path: '/test',
      name:'Test',
      component: resolve => require(['@/view/test'], resolve)
    },
  ],
  mode:'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js